import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import { systemRoutes, authRoutes } from './routes/system'
import setupRouteGuard from './guard'

const createHistory = () => {
  return createWebHashHistory(import.meta.env.VITE_BASE_PATH)
}

const router = createRouter({
  history: createHistory(),
  routes: [...systemRoutes, ...authRoutes],
  strict: true,
  scrollBehavior: () => ({ left: 0, top: 0 }),
})
/**
 * 安装router
 * @param app vue实例
 */
export function setupRouter(app) {
  app.use(router)
  setupRouteGuard(router)
}

export default router
